import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getAsaMeetingYearCounts(context) {
    return axios
      .get("asaMeeting/yearCounts")
      .then((r) => r.data.counts || {})
      .catch((e) => {
        context.dispatch("triggerError", e);
        return {};
      });
  },
  getAsaMeetings(context, year) {
    return axios
      .get(`asaMeeting?${year ? `year=${year}&` : ""}sort=-date&perPage=1000`)
      .then((r) => r.data.data || [])
      .catch((e) => {
        context.dispatch("triggerError", e);
        return [];
      });
  },
  getAsaMeeting(context, id) {
    return axios
      .get("asaMeeting/" + id)
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },
  createAsaMeeting(context, item) {
    return axios
      .post("asaMeeting", item)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("asaMeeting.saved"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },
  updateAsaMeeting(context, item) {
    return axios
      .put("asaMeeting/" + item._id, item)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("asaMeeting.saved"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },
  deleteAsaMeeting(context, id) {
    return axios
      .delete("asaMeeting/" + id)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("asaMeeting.deleted"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },
  getAsaMeetingPdf(context, id) {
    return axios
      .get("asaMeeting/" + id + "/pdf")
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },
  getAsaTicketOptions(context) {
    return axios
      .get("ticket?perPage=1000&sort=-createdAt")
      .then((r) => (r.data.data || []).map((t) => ({
          _id: t._id,
          title: t.title,
          users: t.users || [],
          externalUsers: t.externalUsers || [],
          dueDate: t.dueDate || null,
          priority: t.priority || 1,
        })))
      .catch(() => []);
  },
};

export default actions;
